import { BrokerAgreementBorrower } from '../../../../../../../queries/brokerAgreementQueries';

/** The agreement borrower's business street lines, then city, state and zip (only when all three are known). */
export const BorrowerAddress = ({ borrower }: { borrower: BrokerAgreementBorrower }) => {
    const address = borrower.businessAddress;

    return (
        <>
            {address?.street1 && <div>{address.street1}</div>}
            {address?.street2 && <div>{address.street2}</div>}
            {address?.city && address.state && address.zipCode && (
                <div>
                    {address.city}, {address.state} {address.zipCode}
                </div>
            )}
        </>
    );
};
